import React, { Component } from "react"
import { Link } from "gatsby"
import logo from "../../images/AP_Icon.png"
import { FaCartArrowDown } from "react-icons/fa"
import { VscMenu } from "react-icons/vsc"
import { IconContext } from "react-icons"

export default class Navbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // prevScrollpos: window.pageYOffset,
      prevScrollpos: this.pageYOffset,
      visible: true,

      navbarState: false,
      navbarClass: "collapse navbar-collapse",
      menus: [
        {
          id: 1,
          menuItem: "Home",
          url: "/",
        },
        {
          id: 2,
          menuItem: "About",
          url: "/about",
        },
        {
          id: 3,
          menuItem: "Services",
          url: "/services",
        },
        {
          id: 4,
          menuItem: "Contact",
          url: "/contact",
        },
      ],
    }
  }
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll)
  }
  handleScroll = () => {
    let cached = null
    if (!cached) {
      setTimeout(() => {
        if (window.scrollY > 2) {
          q2.className = "navbar sticky-top scroll navbar-expand-sm brand"
          q.style.width = "30px"
          q.style.position = "relative"
        } else if (window.scrollY === 0) {
          q2.className =
            "navbar sticky-top navbar-expand-sm bg-theme text-white"
          q.style.width = "50px"
        }
        //you can access the original event at `cached`
        cached = null
      }, 200)
    }
    cached = this
    let q = document.querySelector(".imag")
    let q2 = document.querySelector(".navbar")
  }

  myToggler = () => {
    // let q3 = document.querySelector(".bg-theme")
    this.state.navbarState
      ? this.setState({
          navbarState: false,
          navbarClass: "collapse navbar-collapse",
        })
      : this.setState({
          navbarState: true,
          navbarClass: "collapse navbar-collapse show",
        })
  }

  render() {
    return (
      <nav className="navbar navbar-expand-sm bg-theme text-white">
        {/* <img src={Nav} alt="" /> */}
        <Link to="/" className="navbar-brand ml-2">
          <img
            className="brand imag"
            src={logo}
            alt="logo goes here"
            width="50px"
          ></img>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={this.myToggler}
        >
          <IconContext.Provider value={{ color: "white" }}>
            <VscMenu className="menu-icon" />
          </IconContext.Provider>
          {/* <span className="text-white">menu</span>         */}
        </button>
        <div className={this.state.navbarClass}>
          <ul className="navbar-nav ml-auto mr-2">
            {this.state.menus.map(menu => {
              return (
                <li key={menu.id} className="nav-item">
                  <Link to={menu.url} className="nav-link text-white">
                    {menu.menuItem}
                  </Link>
                </li>
              )
            })}
            {/* <li className="nav-item">
              <Link to ="/" className="nav-link text-white">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link to ="/" className="nav-link text-white">
                About
              </Link>
            </li> */}
            <li className="nav-item">
              <Link
                to="/services"
                className="nav-link text-white snipcart-checkout"
              >
                <FaCartArrowDown className="cart-icon snipcart-item" />
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}
